<!--
 * @Author: Latte
 * @Date: 2021-10-20 09:22:09
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-08 09:16:58
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\QuizManagement\QuizDetail.vue
-->
<template>
	<div>
		<el-form ref="form" :model="formData" label-position="top" v-loading="loading">
			<el-form-item label="创建时间" prop="createTime">
				<el-input v-model="formData.createTime" disabled></el-input>
			</el-form-item>
			<el-form-item label="创建者" prop="nickname">
				<el-input v-model="formData.nickname" disabled></el-input>
			</el-form-item>
			<el-form-item label="标题" prop="title" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
				<el-input v-model="formData.title"></el-input>
			</el-form-item>
			<el-form-item label="描述" prop="description">
				<el-input v-model="formData.description"></el-input>
			</el-form-item>
			<el-form-item label="关键字" prop="keyWord">
				<el-input v-model="formData.keyWord"></el-input>
			</el-form-item>
			<el-form-item label="阅读量" prop="pageViews">
				<el-input v-model="formData.pageViews" disabled></el-input>
			</el-form-item>
			<el-form-item label="回答个数" prop="answerCount">
				<el-input v-model="formData.answerCount" disabled></el-input>
			</el-form-item>
			<el-form-item label="想问用户个数" prop="wantAskCount">
				<el-input v-model="formData.wantAskCount" disabled></el-input>
			</el-form-item>
			<el-form-item label="最佳答案状态" prop="BestAsStatus">
				<el-select v-model="formData.bestAsStatus" disabled>
					<el-option label="已标" :value="1"></el-option>
					<el-option label="未标" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="类型" prop="category" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
				<el-select v-model="formData.category">
					<el-option v-for="item in categories" :key="item.forumCategoryID" :label="item.categoryName"
						:value="item.categoryName"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="userDataTypeOption.length > 0" label="所属领域" prop="userDataType"
				:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
				<el-select v-model="formData.userDataType">
					<el-option v-for="item in userDataTypeOption" :key="item.value" :label="item.name"
						:value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="悬赏麦粒值" prop="worth" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
				<el-input v-model="formData.worth"></el-input>
			</el-form-item>
			<el-form-item label="设为置顶" prop="isTop">
				<el-select v-model="formData.isTop">
					<el-option label="否" :value="false"></el-option>
					<el-option label="是" :value="true"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="设置发布模式" prop="publishMode">
				<el-select v-model="formData.publishMode" style="width: 300px">
					<el-option label="公开 (所有用户可见)" :value="0"></el-option>
					<el-option label="私有 (用户不可见,仅邀请的专家可见)" :value="1"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>

				<el-button type="primary" size="small" @click="handleUpdate">保存</el-button>
				<el-button size="small" type="danger" @click="handleDeleteProblem()"
					:type="formData.isDeleted ? 'warning' : 'danger'">{{formData.isDeleted ?'恢复'  :'删除' }}
				</el-button>
			</el-form-item>

			<el-form-item>
				<template solt="label">
					<div>
						<el-row style="display: flex;">
							<el-col>
								<p style="font-weight: 700;">图片</p>
							</el-col>
							<el-col align="right">
								<el-upload ref="uploadAvatarRef" accept=".png,.jpg" action="" :http-request="uploadFile"
									:limit="1" :show-file-list="false">
									<el-button size="small" type="primary">上传图片</el-button>
								</el-upload>
							</el-col>
						</el-row>
					</div>

				</template>
				<el-table :data="problemFileList" border="">
					<el-table-column label="#" prop="problemFileId" align="center" width="150px"></el-table-column>
					<el-table-column label="文件" prop="fileUrl" align="center" width="150px">
						<template slot-scope="scope">
							<div style="width: 100px; height: 100px;position: relative;">
								<el-image style="width: 100px; height: 100px;" fit="scale-down" :key="scope.row.fileUrl"
									:src="getImageUrl(scope.row)" lazy :preview-src-list="[getImageUrl(scope.row)]">
								</el-image>
								<i v-if="scope.row.fileType === 1" class="el-icon-video-play"
									style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
									@click.stop="viewVideo(scope.$index, scope.row)"></i>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="文件类型" prop="fileType" align="center">
						<template slot-scope="scope">
							<el-tag :type="fileType(scope.row)">{{
                fileLabel(scope.row)
              }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" prop="createTime" align="center">
						<template slot-scope="scope">
							{{ scope.row.createTime | formatDateTime }}
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type="danger" size="small" @click="handleRemoveProblemFile(scope.row)">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination v-show="problemFileTotalCount > problemFilePageSize" background
					layout="prev, pager, next" :total="problemFileTotalCount" :page-size="problemFilePageSize"
					:current-page="problemFileCurrentPage" @current-change="probleFileCurrentChange" />
				<!-- <el-image
          :fit="scale-down"
          style="height: 400px"
          v-for="item in formData.fileList" 
          :key="item.SeriaNum"
          :src="`${config.RESOURCES + item.FileUrl}`" 
          lazy
        ></el-image> -->
			</el-form-item>
		</el-form>

		<!-- 查看视频 -->
		<el-dialog title="查看视频" :visible.sync="viewVideoDialog" width="60%" :destroy-on-close='true'>
			<video :src="getVideoUrl(videoEntity)" controls style="width: 100%;height: 60vh;overflow: auto;">
			</video>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getProblemDetail,
		getAnswerList,
		getProblemFileList,
		deleteProblemFile,
		updateProblem,
		addProblemFile
	} from "@/api/mai/quizManagement/quizDetail";
	import {
		getProblemConfig,
	} from "@/api/mai/quizManagement/quizManagement"
	import {
		getCloudUrl
	} from "@/utils/urlutil"
	import {
		getCategoryList,
		deleteProblemOrBack
	} from "@/api/mai/quizManagement/quizManagement";
	import {
		handleRes
	} from "@/utils/handleRes"
	import {
		uploadFile2OSS
	} from "@/utils/OSSUpload"
	import {
		getOSSUploadInfo
	} from "@/api/system/CSDocument/file";
	import {
		printObj
	} from "@/utils/debug"
  import {getUserType} from "@/utils/userutil";
	export default {
		props: {
			problemId: Number,
		},
		data() {
			return {
				loading: false,
				formData: {
					fileList: [],
				},
				categories: [], // 问题类型
				viewVideoDialog: false,
				videoEntity: {},
				//答案文件分页
				problemFileTotalCount: 0, // 列表总数
				problemFilePageSize: 3, // 单页条数
				problemFileCurrentPage: 1, // 当前页码
				problemFileList: [],
				userDataTypeOption: [],
				problemConfig: {} //问答配置，用到上传文件数量
			};
		},
		computed: {
			fileType() {
				return function(row) {
					switch (row.fileType) {
						case 0:
							return "primary";
						case 1:
							return "success";
						case 2:
							return "info";
					}
				};
			},
			fileLabel() {
				return function(row) {
					switch (row.fileType) {
						case 0:
							return "图片";
						case 1:
							return "视频";
						case 2:
							return "语言";
					}
				};
			},
		},
		async created() {
      this.userDataTypeOption = getUserType()
			this.refreshCurrentList();
			this.fetchCategory();
			// this.getProblemConfig()
		},
		methods: {
			getProblemConfig() {
				getProblemConfig().then(res => {
					handleRes(res, () => {
						this.problemConfig = res.data
					})
				})
			},
			probleFileCurrentChange(curPage) {
				this.problemFileCurrentPage = curPage
				this.getFileList()
			},
			getVideoUrl(entity) {
				console.log(getCloudUrl(entity.fileUrl))
				return getCloudUrl(entity.fileUrl)
			},
			getImageUrl(entity) {
				return getCloudUrl(entity.fileType === 1 ? entity.faceUrl : entity.fileUrl)
			},
			viewVideo(index, entity) {

				this.videoEntity = entity;
				this.viewVideoDialog = true;
			},
			refreshCurrentList() {
				this.getProblemDetail();
				this.getFileList();
			},
			/**
			 * @description: 获取问题详情
			 * @param {*}
			 * @return {*}
			 */
			getProblemDetail() {
				this.loading = true;
				getProblemDetail({
					problemId: Number(this.problemId)
				}).then((res) => {
					handleRes(res, () => {
						this.formData = res.data
					})

					this.loading = false;
				});
			},
			/**
			 * @description: 获取文件列表
			 * @param {*}
			 * @return {*}
			 */
			getFileList() {
				this.loading = true;
				getProblemFileList({
					problemId: Number(this.problemId),
					pageNumber: this.problemFileCurrentPage,
					pageSize: this.problemFilePageSize,
				}).then((res) => {
					this.problemFileList = res.data.rows
					this.problemFileTotalCount = res.data.total
					this.loading = false;
				});
			},
			/**
			 * @description: 获取类别
			 * @param {*}
			 * @return {*}
			 */
			fetchCategory() {
				this.categories = [];

				getCategoryList().then((res) => {
					handleRes(res, () => {
						this.categories = res.data;
					})

				});
			},
			/**
			 * @description: 删除图片
			 * @param {*} row
			 * @return {*}
			 */
			handleRemoveProblemFile(row) {
				this.$confirm("是否删除该文件", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteProblemFile({
							problemFileId: row.problemFileId,
						}).then((res) => {
							handleRes(res, () => {
								this.refreshCurrentList();
							})
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "取消操作",
						});
					});
			},
			/**
			 * @description: 保存修改
			 * @param {*}
			 * @return {*}
			 */
			handleUpdate() {
				updateProblem(this.formData).then((res) => {
					handleRes(res, () => {
						this.refreshCurrentList()
					})
				});
			},
			handleDeleteProblem() {
				deleteProblemOrBack({
					problemId: this.problemId
				}).then(res => {
					handleRes(res, () => {

						this.refreshCurrentList()

					})
				})
			},
			/**
			 * 上传文件
			 * @param {Object} file
			 */
			async uploadFile(file) {
				this.$message.success('上传中')
				let ossInfo = (await getOSSUploadInfo({
					DataType: 19,
					ID: this.problemId
				})).resultData;
				let timestamp = new Date().valueOf();
				const fileName = ossInfo.PicSavePath + timestamp + file.file.name.substring(file.file.name.lastIndexOf("."));
				let uploadRes = await uploadFile2OSS(ossInfo, file.file, fileName)
				if (uploadRes.status === 0) {
					let para = {
						"faceUrl": "",
						"fileSize": file.file.size,
						"fileType": 0,
						"fileUrl": "/" + fileName,
						"problemId": this.problemId,
						"serialNum": 0,
						"videoLength": 0
					}
					addProblemFile(para).then(res => {
						handleRes(res, () => {
							this.getFileList()
						})
					})

				} else {
					this.$message({
						type: "error",
						message: "上传失败"
					})
				}
				this.$refs.uploadAvatarRef.clearFiles();
			},
		},
	};
</script>

<style>
</style>
